import React, { useEffect, useState } from 'react'
import userImg from '../../src/Assets/images/apple-touch-icon.png'
import { socket, socketEmit } from '../utils/Socket'
import { SocketConstants } from '../constants/ApiConstants'
import { ChatConstants } from '../constants/ChatConstants'
import { useDispatch } from 'react-redux'
import { formatDateTime, getLocalTime } from '../utils/Helper'
import PageLoader from '../component/layout/PageLoader'
import FrontLoader from '../component/layout/FrontLoader'
import { useRef } from 'react'
import Linkify from 'linkify-react';
import { Link } from 'react-router-dom'

function ChatModal(props: any) {
    const dispatch = useDispatch<any>();
    const [data, setData]: any = useState([])
    const [message, setMessage]: any = useState(null)
    const [loading, setLoading] = useState(true)
    const formRef = useRef<HTMLFormElement>(null);
    const [buttonDisable, setButtonDisable] = useState(false)

    useEffect(() => {
        if (props?.data?.quotation_id) {
            const payload = {
                user_id: props?.data?.user_id,
                quotation_id: props?.data?.quotation_id
            }
            socketEmit(dispatch, SocketConstants?.GetMessageList, ChatConstants?.MESSAGE_LIST, payload)
        }
    }, [props])

    useEffect(() => {
        socket.on('chats_list_response', async (Response: any) => {
            if (Response?.status) {
                setLoading(false)
                const filteredData = Response?.data.filter((item: any) => item?.sender_id == props?.data?.user_id || item?.receiver_id == props?.data?.user_id);
                if (filteredData.length > 0) {
                    setData(Response?.data)
                }
                // setData(Response?.data)
            }
        })
    }, [])

    const handleSubmitMessage = (e: any) => {
        e.preventDefault();
        if (message != '' && message != undefined && message.trim('') != '') {
            setButtonDisable(true)
            const payload = {
                text: message.trim(''),
                sender_type: "1",
                quotation_id: props?.data?.quotation_id,
                sender_id: props?.data?.user_id,
                receiver_id: '1'
            }
            if (formRef.current) {
                formRef.current.reset();
            }
            setMessage('')
            socket.emit('send_message', payload, async (Response: any) => {
            })
        }
    }

    socket.on('send_message_response', async (Resp: any) => {
        if (Resp?.status) {
            if (formRef.current) {
                formRef.current.reset();
            }
            setMessage('')
            setLoading(false)
            setButtonDisable(false)
            if (props?.data?.user_id == Resp?.data?.sender_id || props?.data?.user_id == Resp?.data?.receiver_id) {
                setData([...data, Resp?.data])
            }
            // setData([...data, Resp?.data])
        }
    })

    useEffect(() => {
        const container = document.querySelector('#modal-dialog-scrollable')
        if (container) {
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth'
            })
        }
    }, [data])

    const renderLink = ({ attributes, content }: any) => { // target to link
        const { href, ...props } = attributes;
        if (href.startsWith('http') || href.startsWith('//')) {
            return <a href={href} target="_blank" rel="noopener noreferrer" {...props}>{content}</a>;
        } else {
            return <Link to={href} {...props}>{content}</Link>;
        }
    };

    return (
        <>
            {loading ? <FrontLoader /> : null}
            <div className="modal fade com-modal short-modal chat-modal show" id="chatModal" aria-labelledby="chatModalLabel" aria-hidden="false" style={{ display: "block" }} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="chat-user-profile">
                                <img className="chat-user-img" src={userImg} alt="" />
                                <span className="chat-user-name">Quote N Buy Admin</span>
                            </div>
                            <button type="button" onClick={() => props?.setChatshow(false)} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start" id='modal-dialog-scrollable'>

                            <div className="chat-modal-body">
                                {data.length > 0 && data.map((res: any, i: any) => (
                                    <div className={res?.sender_type == "0" ? "chat-msg-single msg-receive" : 'chat-msg-single msg-send'} key={i}>
                                        <div className='msg-receive-img-with'>
                                            {res?.sender_type == "0" ?
                                                <img src={userImg} alt="" />
                                                : null}
                                            <div>
                                                <div className="chat-msg-single-msg ">
                                                    <Linkify options={{ render: renderLink }}>
                                                        {/* {chat_data?.message} */}
                                                        {res?.text}
                                                    </Linkify>
                                                </div>
                                                <span className="chat-msg-single-time">{res?.created_at ? getLocalTime(res?.created_at).localTime : ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}









                            </div>
                        </div>
                        <form ref={formRef} onSubmit={handleSubmitMessage}>
                            <div className="modal-footer">
                                <div className="chat-footer">
                                    {/* <div className="choose-media">
                                    <input type="file" id="chooseChatImg" />
                                    <label htmlFor="chooseChatImg">
                                        <img src={cameraImg} alt="" />
                                    </label>
                                </div> */}
                                    <div className="chat-input-grp">
                                        <input className="type-chat-msg form-control" onChange={(e) => setMessage(e?.target?.value)} type="text" placeholder="Write a message..." value={message} />
                                        {buttonDisable ?
                                            <button disabled className="msg-send-btn"   ><i className="icon-sent"></i></button>
                                            :
                                            <button className="msg-send-btn" type='submit'  ><i className="icon-sent"></i></button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChatModal